import React from 'react';
import { Alert, Button, Box, Typography } from '@mui/material';
import { Refresh, ErrorOutline } from '@mui/icons-material';

interface RetryableErrorProps {
  error: string;
  onRetry: () => void;
  title?: string;
  showDetails?: boolean;
}

export const RetryableError: React.FC<RetryableErrorProps> = ({
  error,
  onRetry,
  title = 'Failed to load data',
  showDetails = false
}) => {
  return (
    <Alert 
      severity="error" 
      icon={<ErrorOutline />}
      sx={{ mb: 2 }}
    >
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {error}
      </Typography>
      {showDetails && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
          If this problem persists, please check your internet connection or contact support.
        </Typography>
      )}
      <Box>
        <Button
          variant="outlined"
          startIcon={<Refresh />}
          onClick={onRetry}
          size="small"
        >
          Try Again
        </Button>
      </Box>
    </Alert>
  );
};
